// extracted by mini-css-extract-plugin
export default {"container":"team_container__fC6zr","team":"team_team__JVZWV","row":"team_row__igyXQ","person":"team_person__Ys0zv"};